import { render, staticRenderFns } from "./plattransactionrecord.vue?vue&type=template&id=2a7f8e16&scoped=true&"
import script from "./plattransactionrecord.vue?vue&type=script&lang=js&"
export * from "./plattransactionrecord.vue?vue&type=script&lang=js&"
import style0 from "./plattransactionrecord.vue?vue&type=style&index=0&id=2a7f8e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f8e16",
  null
  
)

export default component.exports